<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.editSupervisor") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-image-upload-input
            col="12"
            identifier="supervisor_avatar"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.personalImage')"
            @selectImage="selectImage"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            required
          />

          <base-input
            col="6"
            type="email"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            required
          />

          <base-input
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.mobileNumber')"
            v-model.trim="data.mobile"
            required
          />

          <base-select-input
            col="6"
            :optionsList="cities"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model="data.city"
            required
          />

          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditSupervisor",

  data() {
    return {
      isWaitingRequest: false,
      cities: [],
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        email: null,
        mobile: null,
        city: null,
        active: true,
      },
    };
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    async fetchCities() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "cities",
          params: {
            page: 0,
            limit: 0,
            status: 1,
          },
        });
        const cities = res.data.data?.data || res.data.data || [];
        this.cities = cities.map((city) => ({
          ...city,
          name: city.name || city.name_ar || city.name_en,
        }));
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },

    async showSupervisor() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `supervisors/${this.$route.params.id}`,
        });
        const item =
          res.data.data?.supervisor ||
          res.data.data?.user ||
          res.data.data?.rep ||
          res.data.data;

        this.data.image.path = item?.avatar;
        this.data.name = item?.name;
        this.data.email = item?.email;
        this.data.mobile = item?.mobile;
        this.data.active = !!item?.is_active;
        this.data.city = item?.city
          ? {
              ...item.city,
              name: item.city.name || item.city.name_ar || item.city.name_en,
            }
          : null;
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },

    validateFormInputs() {
      this.isWaitingRequest = true;

      if (
        !this.data.name ||
        this.data.name.length < 2 ||
        this.data.name.length > 100
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      }

      if (!this.data.email || this.data.email.length > 100) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.email"));
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.data.email)) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.email"));
        return;
      }

      const mobile = String(this.data.mobile || "")
        .replace(/\D/g, "")
        .slice(0, 10);
      this.data.mobile = mobile;
      if (mobile.length !== 10) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mobileNumber"));
        return;
      }

      if (!this.data.city?.id) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.city"));
        return;
      }

      this.submitForm();
    },

    async submitForm() {
      const requestData = new FormData();

      requestData.append("name", this.data.name);
      requestData.append("email", this.data.email);
      requestData.append("mobile", this.data.mobile);
      requestData.append("city_id", this.data.city.id);
      requestData.append("is_active", this.data.active ? 1 : 0);
      requestData.append("_method", "put");

      if (this.data.image.file) {
        requestData.append("avatar", this.data.image.file);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `supervisors/${this.$route.params.id}`,
          data: requestData,
        });
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/supervisors/all" });
      } catch (error) {
        this.$message.error(error?.response?.data?.message);
      } finally {
        this.isWaitingRequest = false;
      }
    },
  },

  async created() {
    await this.fetchCities();
    await this.showSupervisor();
  },
};
</script>
